import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

export const getCustomerName = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.POV2}/GetCustomer`,
  });
};

let getVendorPurchaseOrdersEffectCancelToken = () => {};
export const getVendorPurchaseOrdersEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetPurchaseOrder`,
  });
};

export const getPOInfoEffect = (data) => {
  getVendorPurchaseOrdersEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getVendorPurchaseOrdersEffectCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.POV2}/GetPoItem`,
  });
};

export const getPackageTypesService = () => {
  return axiosInstance.request({
    method: 'GET',
    url: `${API.POV2}/GetPackageType`,
  });
};

export const getPackagesEffect = (data) => {
  getVendorPurchaseOrdersEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getVendorPurchaseOrdersEffectCancelToken = c;
    }),
    method: 'get',
    params: data,
    url: `${API.POV2}/PckageRead`,
  });
};

export const getBarCodeDetails = (data) => {
  return axiosInstance.request({
    method: 'GET',
    params: data,
    url: `${API.POV2}/GenerateBarcode`,
  });
};

export const saveRegularOrderDataAPI = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/PoItemValidation`,
  });
};

let getFooterValuesCancelToken = () => {};
export const getFooterValues = (data) => {
  getFooterValuesCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getFooterValuesCancelToken = c;
    }),
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/GetFooterContent`,
  });
};

export const savePackageEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/SavePackage`,
  });
};

export const saveShipmentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/CreateShipmentValidation`,
  });
};

export const getShippersList = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetShipper`,
  });
};
export const getConsigneeList = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetConsignee`,
  });
};

export const getShipmentDetailsLists = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetShipmentDetails`,
  });
};

export const getShipmentItemDetailsLists = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetShipmentItemDetails`,
  });
};

export const getShipmentSummaryList = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetShipmentSummery`,
  });
};

export const getShipmentLadingList = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.POV2}/GetBillOfLad`,
  });
};

export const createPovShipmentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/SaveShipment`,
  });
};

export const getRoutingGuideEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/GetRoutingGuide`,
  });
};

export const saveVendorAddressEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/SaveVendorAddress`,
  });
};

export const deleteVendorAddressValue = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/DeleteVendorAddress`,
  });
};

export const cancelShipmentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/CancelDraftShipment`,
  });
};

let getShipmentItemDetailsCancelToken = () => {};
export const getShipmentItemDetails = (data) => {
  getShipmentItemDetailsCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentItemDetailsCancelToken = c;
    }),
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/GetShipmentItemDetails`,
  });
};

let getVendorSearchValuesCancelToken = () => {};
export const getVendorSearchValues = (params) => {
  getVendorSearchValuesCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getVendorSearchValuesCancelToken = c;
    }),
    data: params,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/GetVendorAddress`,
  });
};

export const getCustomerRouterSettingService = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.POV2}/GetCustomerRoutingSettings`,
  });
};

export const resetOrderListService = (params) => {
  return axiosInstance.request({
    data: params,
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    url: `${API.POV2}/ResetReleaseOrder`,
  });
};

export const shipDateChangeEmailNotification = (params) => {
  return axiosInstance.request({
    data: params,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.POV2}/ShipDateChangeEmailNotification`,
  });
};

// TODO: use useGetVendorShipmentConfig
export const getVendorFieldsVisibilityEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.POV2}/GetVendorFieldsVisiblity`,
  });
};

export const validateEarlyShipmentRestrictionEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'POST',
    url: `${API.POV2}/GetEarlyShipmentRestriction`,
  });
};

export const getVendorPortCodes = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.POV2}/GetVendorPortCode`,
  });
};
